import React, { useEffect, useRef, useState } from 'react'
import './template-game-preview.styles.scss'
import { useLocation, useParams } from 'react-router-dom'
import { getGameDataFromDb, getGameElementsFromRtDb } from '@/utils/getDataFromDb'
import ImageContainer from '@/components/SHARED/image-container/image-container.component'
import { off } from 'firebase/database'
import { properCase } from '@/utils/properCase'
import ElementPreviewItem from './element-preview-item.component'

const TemplateGamePreview = () => {

    const { templatePath } = useParams();
    const [ gameData, setGameData ] = useState(null);
    const [ elementType, setElementType ] = useState(null);
    const [ gameElements, setGameElements ] = useState([]);
    const [ elementTypes, setElementTypes ] = useState([]);
    const [ teams, setTeams ] = useState([]);
    const elementsRef = useRef({});
    const teamsRef = useRef();
    const location = useLocation();
    let gameListener;
    let elementsListener;
    let teamsListener;

    useEffect(() => {

        return () => {
            if (gameListener) gameListener();
            if (elementsListener) off(elementsListener);
        }
    }, [])

    useEffect(() => {
        if (!templatePath || !location) return;
        getGameData();
    }, [templatePath, location])

    function getGameData() {
        let status = 'active';
        if (location.pathname.includes('/archive/')) {
            status = 'archived';
        }
        getGameDataFromDb(
            {
                'gamePath': templatePath,
                'status': status,
                'callback': callback,
                'handleListener': handleListener
            }
        )
        function callback(data) {
            setGameData(data);
            getGameElements(data);
            // getTeams(data);
        }
        function handleListener(listener) {
            gameListener = listener;
        }
    }

    function getGameElements(data) {
        getGameElementsFromRtDb(
            {
                'gameId': data.gameId,
                'callback': callback,
                'handleListener': handleListener
            }
        )
        function callback(data) {
            elementsRef.current = {
                ...elementsRef.current,
                ...data
            }
            console.log('elementsRef', elementsRef.current);
            setGameElements(elementsRef.current);
            setElementTypes([...new Set(Object.values(elementsRef.current).map(el => el.type))]);
        }
        function handleListener(listener) {
            elementsListener = listener;
        }
    }

    return (
        <div className='template-game-preview'>
            {
                (gameData) 
                ?
                <div className='game-preview'>
                    <ImageContainer
                        src={gameData.header} />
                    <h2>{gameData.gameName.replace(' [TEMPLATE]', '')}</h2>
                    <div dangerouslySetInnerHTML={{__html: gameData.desc}}></div>
                    <div className="g-space-1"></div>
                    <p><b>View Included Elements</b></p>
                    <div className='game-preview-select'>
                        <ImageContainer
                            src={gameData.icon}
                            className={'game-preview-icon'} />
                        <div className='field small'>
                            <select
                                value={elementType ?? ''}
                                onChange={(e) => setElementType(e.target.value)}>
                                <option value=''>Select Element Type</option>
                                {
                                    (elementTypes) &&
                                    elementTypes.map((el, index) => (
                                        <option key={el} value={el}>{properCase(el)}</option>
                                    ))
                                }
                            </select>
                        </div>
                    </div>
                    {
                        (elementType && gameElements) &&
                        <div className='game-preview-elements'>
                            {
                                Object.values(gameElements)
                                    .filter(el => el.type === elementType)
                                    .map((el, index) => (
                                        <ElementPreviewItem
                                            key={el.id}
                                            element={el} />
                                    ))
                            }
                        </div>
                    }
                </div>
                :
                <div className='loading'>
                    <p>Loading game data...</p>
                </div>
            }
        </div>
    )
}

export default TemplateGamePreview